export const faqPageHero = {
  title: 'Frequently Asked Questions',
  subtitle:
    'Answers about nationwide parcel research, listing maps, property tours, and sharing with buyers.',
};

export const faqItems = [
  {
    question: 'What is Community View?',
    answer:
      'Community View (communityview.ai) is parcel map software for real estate agents. Search parcels nationwide, find property owners, review ownership details, build listing maps, and send digital property tours buyers can open on any device.',
  },
  {
    question: 'Does Community View work nationwide?',
    answer:
      'Yes. Parcel search and mapping use nationwide Regrid data. Search across the country and filter results by county when you want to narrow results to a specific market.',
  },
  {
    question: 'Can I filter search results by county?',
    answer:
      'Yes. Search nationwide, then filter by one or multiple counties so you only see parcels in the areas you care about. Search by owner name, address, or parcel ID.',
  },
  {
    question: 'What property details can I see on a parcel?',
    answer:
      'Click any parcel for ownership and assessor-style records — owner and mailing address, APN, legal description, acreage, assessed values, building size, zoning, flood zone data, and more when available from the source county.',
  },
  {
    question: 'What map layers are available?',
    answer:
      'Toggle ownership boundaries, public land, conservation easements, soil, surface water, wetlands, opportunity zones, principal aquifers, transmission lines, wildfire hazard, and US boundary layers including counties, places, congressional districts, and tribal lands.',
  },
  {
    question: 'What are listing maps?',
    answer:
      'Listing maps are custom maps you build in Community View — property boundaries, labeled points for wells and outbuildings, photos pinned to features, and annotations. Export or share a link with buyers.',
  },
  {
    question: 'What are property tours?',
    answer:
      'Property tours are shareable, interactive presentations for a listing — your parcel on the map, nearby schools, dining, trails, and recreation, plus a link you can send to buyers from any device.',
  },
  {
    question: 'Can I send maps and tours to buyers?',
    answer:
      'Yes. Build a listing map or property tour and share a link. Buyers do not need an account to view a shared map or tour.',
  },
  {
    question: 'What is the difference between a listing map and a property tour?',
    answer:
      'Listing maps are annotated maps you design for a property — boundaries, icons, photos, and notes. Property tours are slide-based presentations that combine map context, orbit views, and nearby amenity highlights in one shareable experience.',
  },
  {
    question: 'Is there a mobile app?',
    answer:
      'Yes. Community View is available on iOS, and the web app works on mobile browsers for search, maps, and sharing tours and listing maps.',
  },
  {
    question: 'What payment methods do you accept?',
    answer:
      'We accept all major credit and debit cards through secure Stripe payment processing.',
  },
  {
    question: 'Is there a free trial?',
    answer:
      'Paid plans include a 14-day free trial so you can search parcels, build maps, and create tours before you commit.',
  },
  {
    question: 'Can I cancel anytime?',
    answer:
      'Yes. Cancel your subscription at any time. You keep access until the end of your billing period.',
  },
  {
    question: 'Can I switch between plans?',
    answer:
      'Yes. Upgrade or downgrade at any time. Changes apply on your next billing cycle.',
  },
  {
    question: 'Do you offer brokerage or team pricing?',
    answer:
      'Yes. Contact us for Enterprise pricing with multiple seats, onboarding, and dedicated support.',
  },
];
